import { CircleQuestionMark } from "lucide-react"
import { openTab } from "shared-web/lib/openTab"
import { toast } from "shared-web/lib/toast"

import {
  PopoverMenu,
  PopoverMenuProps,
  useLocalSearchPopoverMenu,
} from "components/composite/popover"
import { openIntercom } from "layouts/hooks/useIntercom"
import { supportNumber } from "lib/constants"
import { RUNDOCS_WELCOME } from "lib/rundocs"

export function SupportMenu({
  className,
  style,
}: Pick<PopoverMenuProps, "className" | "style">) {
  const { popoverMenuProps } = useLocalSearchPopoverMenu({
    items: [
      {
        key: "explore-rundocs",
        label: "Explore the Rundocs",
        onSelect: () => {
          openTab(RUNDOCS_WELCOME)
        },
      },
      {
        key: "support-chat",
        label: "Chat with support",
        onSelect: openIntercom,
      },
      {
        key: "call-support",
        label: `Call support ${supportNumber()}`,
        onSelect: () => {
          navigator.clipboard.writeText(supportNumber())
          toast.success({ message: "Support phone number copied to clipboard" })
        },
      },
    ],
    onSelect: ({ onSelect }) => {
      onSelect()
    },
    keyExtractor: (item) => item.key,
    labelExtractor: (item) => item.label,
  })

  return (
    <PopoverMenu
      buttonVariant="default"
      buttonMode="secondary"
      buttonSize="medium"
      buttonLeftIcon={CircleQuestionMark}
      buttonTitle="Support"
      className={className}
      style={style}
      {...popoverMenuProps}
    />
  )
}
